<template>
    <div class="findPwd">
       <forget-pwdTitle :active="4"></forget-pwdTitle>
        <div class="findPwd-page_main">
            <i class="el-icon-success"></i>
            <p>恭喜您，登录密码找回成功！</p>
            <el-button type="primary" @click="toLink">确认</el-button>
        </div>

    </div>
</template>

<script>
import ForgetPwdTitle from "../../public/forgetPwdTitle";
export default {
  name: "findPwdStep4",
  components: {
    forgetPwdTitle: ForgetPwdTitle
  },
  data() {
    return {
      ruleForm: {
        email: ""
      }
    };
  },
  methods: {
    toLink() {
      window.location.href = "https://mail.tongji.edu.cn";
    }
  },
  mounted() {
    const self = this;
    const findPwdToken = localStorage.getItem("findPwdToken");
    if (!findPwdToken) {
      self.$router.push({ name: 'Step1'});
      self.$alert("认证身份信息已过期，请重新验证", "错误提示", {
        confirmButtonText: "确定",
        type: "error",
        center: true,
        customClass: "errMessage",
        callback: action => {
          self.$router.push({ name: 'Step1'});
        }
      });
    } else {
      localStorage.setItem("findPwdToken", "");
      localStorage.setItem("findPwdXGH", "");
    }
  }
};
</script>

<style scoped>
.forgetPwd {
  width: 100%;
}
.emailAddr {
  width: 195px;
}
.emailName {
  display: inline-block;
  border: 1px solid #dcdfe6;
  width: 170px;
  text-align: center;
  margin-left: -12px;
  line-height: 38px;
}
.findPwd-page_main {
  width: 782px;
  margin: 0 auto;
  background: #fbfbfd;
  margin-top: 50px;
  padding: 50px 0;
  text-align: center;
}

.findPwd-page_main i {
  font-size: 60px;
  color: #67c23a;
}
.findPwd-page_main p {
  font-size: 18px;
  margin: 25px 0;
}
.findPwd-page_main button {
  width: 130px;
  height: 40px;
  line-height: 40px;
  padding: 0;
  color: #fff;
  font-size: 16px;
}
@media (max-width: 767px) {
  .findPwd{
    display:flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    height: 100vh;
    justify-content: center;
  }
  .findPwd-page_main{
    width: 96%;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding:20px 0 !important;
  }
  /deep/ .el-form-item__label{
    font-size: 0.8rem;
  }
  .emailAddr{
    width: 55%;
    font-size: 0.8rem;
  }
  .emailName{
    font-size: 0.8rem;
    width: 45%;
  }
  .findPwd-page_main p{
    font-size: 0.9rem;
  }
  .findPwd-page_main button{
    font-size: 0.8rem;
    display:flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 30px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .findPwd{
    display:flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    height: 100vh;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/reSetPwd/step4.vue